export const decodeToken = (token) => {
	const str = token.split('.').length > 1 ? token.split('.')[1] : token;
	return JSON.parse(atob(str));
}

export const formatCurrency = (number = 0) => {
	return new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(number);
};
